// English customer copy follows the canonical Web v3 October 2 simplification.
// Server-owned policy/outcome text, state transitions and permitted actions remain unchanged.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  "appt.v3.requestHeading": "Your request",
  "appt.v3.requestReference": "Reference number",
  "appt.v3.atAppointment": "Pay at the appointment",
  "appt.v3.depositMode": "Deposit",
  "appt.v3.fullMode": "Payment in app",
  "appt.v3.paymentMode": "Payment",
  "appt.v3.policyReadUnavailable": "Cancellation policy unavailable.",
  "appt.v3.staleDetails": "Before cancellation",
  "appt.v3.allocationHeading": "Cancellation amounts",
  "appt.v3.moneyDetailsUnavailable": "Contact support to check the cancellation amounts.",
  "appt.v3.refundAmount": "Refund amount",
  "appt.v3.refundTiming": "",
  "appt.v3.keepRequest": "Keep my request",
  "appt.v3.cancelRequest": "Cancel this request",
  "appt.v3.viewAppointment": "View appointment",
  "appt.v3.requestCancelled": "Your request is cancelled",
  "appt.v3.cancelRequestHeading": "Cancel this request?",
  "appt.v3.cancelReviewHeading": "Cancel this appointment?",
  "appt.v3.requestedShort": "Waiting for confirmation.",
  "appt.loading": "Loading your appointment…",
  "appt.unavailable.title": "This link isn’t available",
  "appt.unavailable.body": "Check the link you received.",
  "appt.unavailable.hint": "",
  "appt.error.title": "We couldn’t load this appointment",
  "appt.error.body": "",
  "appt.error.retry": "Try again",
  "appt.heading": "Your appointment",
  "appt.where": "Where",
  "appt.zoneNote": "Times are shown in {business}’s local time.",
  "appt.confirmation": "Confirmation",
  "appt.unavailableValue": "Unavailable",
  "appt.receiptUnavailable.title": "Some appointment details are unavailable.",
  "appt.receiptUnavailable.body": "",
  "appt.receiptUnavailable.reload": "Reload details",
  "appt.receiptUnavailable.support": "Contact support",
  "appt.status.label": "Status",
  "appt.status.cancelled": "Cancelled",
  "appt.status.completed": "Completed",
  "appt.status.confirmed": "Confirmed",
  "appt.status.pending": "Awaiting confirmation",
  "appt.status.noShow": "Recorded as a no-show",
  "appt.status.requested": "Requested",
  "appt.status.declined": "Declined",
  "appt.status.expired": "Expired",
  "appt.status.reschedulePending": "Reschedule pending",
  "appt.status.paymentRequired": "Payment required",
  "appt.cancel.start": "Cancel this appointment",
  "appt.cancel.checking": "Checking…",
  "appt.cancel.review.title": "Before you cancel",
  "appt.cancel.review.body": "",
  "appt.cancel.retained": "Kept by {business}",
  "appt.cancel.remaining": "No longer owed at the appointment",
  "appt.cancel.nothingMoves": "No payment changes.",
  "appt.cancel.confirm": "Yes, cancel it",
  "appt.cancel.sending": "Cancelling…",
  "appt.cancel.keep": "Keep my appointment",
  "appt.cancel.blocked.title": "This appointment can’t be cancelled here.",
  "appt.cancel.blocked.body": "Contact {business} to make changes.",
  "appt.cancelled.title": "Your appointment is cancelled",
  "appt.cancelled.body": "",
  "appt.notAllowed.title": "This appointment can’t be cancelled here.",
  "appt.indeterminate.title": "Cancellation needs help",
  "appt.indeterminate.body": "Contact support before booking again.",
  "appt.cancel.offline.title": "You’re offline",
  "appt.cancel.offline.body": "Reconnect to cancel.",
  "appt.failed.title": "Your appointment wasn’t cancelled",
  "appt.failed.body": "",
  "appt.lost.title": "Check your cancellation",
  "appt.lost.body": "Check the status before trying again.",
  "appt.lost.money": "We couldn’t confirm the cancellation amounts. Contact support before booking again.",
  "appt.lost.rechecking": "Checking the current status…",
  "appt.lost.recheckFailed": "Current status unavailable.",
  "appt.lost.recheck": "Check again",
} as const;
